import styled from 'styled-components';

export const Pre = styled.div`
  width: calc(100% - 45px);
  text-align: center;
  background: #EBF6FF;
  border-radius: 10px;
  padding: 26px 13px;
`;

export const Features = styled.div`
  display: flex;
  width: 100%;
  margin: 28px 0;
`;

export const Feature = styled.div`
  width: 100%;
  color: #000000;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  & > span {
    margin-top: 8px;
  }

  b {
    font-weight: 700;
  }
`;

export const Footer = styled.div`
  width: calc(100% - 20px);
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  button {
    width: calc(50% - 9px);
    font-size: 18px;
    border-radius: 20px;
    padding: 6px 25px;
  }
`;
